import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_PRIDE_LOGO = defineFcm('enable_pride_logo').asBoolean().withDefault(false).toConfig({
	owner: 'TBD',
	scope: 'corgi-front-end',
	context: 'Page header',
	description: 'Replace the default logo with a colorful "pride" logo.',
});
